module.exports = __webpack_public_path__ + "img/alert-circle.24925406.svg";